import React, { Component } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import style from './style'
import { cardLogos } from '../../modules/payment/components/CardNumberInput/cardsHelper';
import { GENERIC } from '../../shared/constants';
import useVisaSensoryBranding from '../../hooks/useVisaSensoryBranding';

class SuccessfulPaymentSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showGrayBgBeforeRender: true,
        };
    }

    componentDidMount() {
        const { cardData } = this.props;
        const isScriptLaunched = useVisaSensoryBranding(cardData, cardLogos, window.env.ASSETS_URL);
        
        if (isScriptLaunched) {
            setTimeout(() => {
                this.setState({ showGrayBgBeforeRender: false });
            }, 2000);
        } else { this.setState({ showGrayBgBeforeRender: false });}
    }

    render() {
        const { showGrayBgBeforeRender } = this.state;
        let expiration_date_pyme_nacion;
        const {
            classes,
            last4Digits,
            currency,
            amount,
            first_installment_expiration_date,
            installments,
            authCode,
            date,
            cardData
        } = this.props
        const paymentCardLogo = (cardLogos[cardData.payment_method_id]) ? cardLogos[cardData.payment_method_id] : GENERIC
        if (first_installment_expiration_date)
            expiration_date_pyme_nacion = <p>Pago de la 1° cuota el {first_installment_expiration_date}</p>
        return (
            <React.Fragment>
                {showGrayBgBeforeRender && <div className={classes.grayBackground} />}
                <div id="visa-sensory-branding" />
                <div className={classes.main}>
                    <Typography variant="body1" className={classes.description}>
                        Pagaste con
                        <span>
                            <img
                                id="paymentMethodLogo"
                                className={classes.cardLogo}
                                alt=""
                                src={`${window.env.ASSETS_URL}/images/cards/${paymentCardLogo}.svg`}
                                onError={e => e.target.parentElement.innerHTML = ' tu tarjeta finalizada en '}
                            />
                        </span>
                        <span className={classes.cardDigits} id="cardNumber">**** {last4Digits}</span>
                    </Typography>
                    <Typography variant="body1" className={classes.description}>
                        <span className={classes.price} id="amount">{currency} {amount}</span> en <span id="installments">{installments} {installments > 1 ? "cuotas" : "cuota"}</span>
                        {expiration_date_pyme_nacion}
                    </Typography>
                </div>
                <div className={classes.info}>
                    <Typography variant="body1" className={classes.infoText} id="authorizationCode">Código Autorización: {authCode}</Typography>
                    <Typography variant="body1" className={classes.infoText} id="datetime">Fecha: {date}</Typography>
                </div>

            </React.Fragment>
        )
    }

}

export default withStyles(style)(SuccessfulPaymentSummary)
